// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"25889807","213":"c571e738","239":"e38f2796","252":"107c9cf8","455":"38d2cd96","500":"5f36a453","514":"5bb7d632","791":"17209924"}[chunkId] + ".chunk.js";
};